import { TabModel } from '../../common/types/TabModel';
import { RootStore } from '../../common/stores/context';
import { TabApplicationData } from '../../common/services/types';
import { Disposer } from '../misc';
import { IAppStoreBase } from '../types';

export default abstract class AppStoreBase extends Disposer implements IAppStoreBase {
    constructor(
        readonly tab: TabModel,
        readonly rootStore: RootStore
    ) {
        super();
    }

    get appId() {
        return this.tab.metadata.applicationData.appId as string;
    }

    get appName() {
        return this.tab.metadata.applicationData.appName as string;
    }

    get sessionId() {
        return this.tab.metadata.sessionId as string;
    }

    get sessionState() {
        return this.tab.metadata.sessionState as string;
    }

    get sessionExtension() {
        return this.tab.metadata.applicationData.appExtension as string;
    }

    get projectId() {
        return this.tab.metadata.projectId as string;
    }

    get packageId() {
        return this.tab.metadata.packageId as string;
    }

    get packageName() {
        return this.tab.metadata.packageName as string;
    }

    get applicationData() {
        return this.tab.metadata.applicationData as TabApplicationData;
    }

    get isReloadable() {
        return this.tab.metadata.isReloadable as boolean | undefined;
    }

    removeAppTab() {
        const tabIndex = this.rootStore.tabsStore.tabs.indexOf(this.tab);
        this.rootStore.tabsStore.removeTab(tabIndex);
    }

    abstract dispose(): void;
}
